import React, { useState } from "react";

const FAQItems = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const onClickingFAQ = () => {
    if (isExpanded === false) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  };

  const P = () => {
    return <p className="mt-10">{props.answer}</p>;
  };

  return (
    <button onClick={onClickingFAQ} className="border-2 border-dashed border-neon md:px-20 py-4 text-neon md:text-lg lg:text-xl z-10">
      {props.question}
      {isExpanded && <P />}
    </button>
  );
};

export default FAQItems;
